import React from 'react'
import { Form } from 'react-bootstrap'
import HelpTooltip from './HelpTooltip'

interface InputWithHelpProps {
    label?: string
    helpText?: string
    error?: boolean
    errorMessage?: string
    infoMessage?: string
    [key: string]: any
}

const InputWithHelp: React.FC<InputWithHelpProps> = ({ 
    label, 
    helpText, 
    error, 
    errorMessage, 
    infoMessage, 
    ...inputProps 
}) => {
    return (
        <div>
            {label && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                    <label style={{ margin: 0, fontWeight: '500', fontSize: '14px' }}>
                        {label}
                    </label>
                    {helpText && <HelpTooltip content={helpText} />}
                </div>
            )}
            <Form.Control {...inputProps} />
            {(errorMessage || infoMessage) && (
                <p className={error ? "input-err" : "input-info"}>
                    {error ? errorMessage : infoMessage}
                </p>
            )}
        </div>
    )
}

export default InputWithHelp